import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { clearBlockErrorMessage, parseBillingBlockRows, type WhatsAppBillingBlock } from "@/lib/whatsapp-billing-block";

const POLL_MS = 2 * 60_000;

export function useWhatsAppBillingBlocks(orgId: string | null): WhatsAppBillingBlock[] {
  const { data } = useQuery({
    queryKey: ["whatsapp-billing-blocks", orgId],
    enabled: !!orgId,
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
    retry: false,
    queryFn: async () => {
      const { data: rows, error } = await supabase.rpc("whatsapp_billing_blocks" as never);
      if (error) throw error;
      return parseBillingBlockRows(rows);
    },
  });
  return data ?? [];
}

export function useClearChannelDeliveryBlocks(orgId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (channelIds: string[]) => {
      for (const channelId of channelIds) {
        const { error } = await supabase.rpc("clear_channel_delivery_block" as never, { p_channel_id: channelId } as never);
        if (error) throw error;
      }
    },
    onSuccess: () => {
      toast.success("Listo. El asistente volverá a responder desde el próximo mensaje.");
      queryClient.invalidateQueries({ queryKey: ["whatsapp-billing-blocks", orgId] });
    },
    onError: (error: unknown) => {
      toast.error(clearBlockErrorMessage(error));
    },
  });
}
